import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import axios from 'axios';

const detectUserCountry = async () => {
  try {
    const res = await axios.get('https://ipapi.co/json/');
    console.log('Country:', res.data.country)
    return res.data.country === 'GB' ? 'en-GB' : 'en-US';
  } catch (err) {
    console.error('Failed to detect country, defaulting to en-US');
    return 'en-US';
  }
};

const initI18n = async () => {
  const defaultLang = await detectUserCountry();

  await i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      lng: defaultLang,
      fallbackLng: 'en-US',
      debug: false,
      ns: [
        'translation', 
        'age-verification', 
        'data-tokenization', 
        'decentralized-identity', 
        'about-earthid', 
        'distributed-ledger', 
        'features-page', 
        'industries', 
        'zkp',
        'passwordless',
        'id-wallet',
        'idv',
        'did',
        'biometrics',
        'news',
        'privacy'
      ],     
      defaultNS: 'translation',                    
      interpolation: {
        escapeValue: false,
      },
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',   // <-- UPDATE THIS
      },
    });
};

export { initI18n };
export default i18n;
